import React, { useEffect, useState } from 'react';
import PageLink from 'components/PageLink/PageLink';
import {
  IsCallCenterWorkingTime,
} from 'common/helpers/Callus';
import { useMediaQuery } from 'react-responsive';
import CallUsNowButton from 'components/CallUsNowButton/CallUsNowButton';
import { OpenChatBot } from 'utils/chatBot';
import TagManager from 'react-gtm-module';
import CallBackButton from 'components/CallBackButton/CallBackButton';

interface Props {
  Model?: any;
  PageData?: any;
  handleClick?: any;
  LayoutModel?: any;
  ShowSecondAttempt?: boolean;
  disableWebDeflect?: boolean;
}
const ValidationMessage = ({ Model, PageData, handleClick, LayoutModel, ShowSecondAttempt, disableWebDeflect }: Props) => {
  const showCallUsNowButton = IsCallCenterWorkingTime(
    LayoutModel?.CallCenterDaysHours,
    LayoutModel?.CallCenterHolidays,
  );
  const [callusText, setCallusText] = useState<string>(
    PageData?.CallUsNowButtonText,
  );
  const [callusNumber, setCallusNumber] = useState<string>('');
  const isMobileSize = useMediaQuery({ maxWidth: 767 });
  const handleCallUsNowClick = () => {
    var tagManagerArgs = {
      dataLayer: {
        event: 'button_click',
        checkout_name: 'Single Payment - Logged Out',
        error_message: 'Details not correct',
        button_name: 'Call Now',
        failure_number: ShowSecondAttempt ? '2' : '1'
      }
    }
    TagManager.dataLayer(tagManagerArgs);
    let countryPhoneNumber = LayoutModel.CallCenterPhoneNumber;
    setCallusText(countryPhoneNumber || '');
    setCallusNumber(countryPhoneNumber);
  };

  const handleTryAgainButtonClick = () => {
    var tagManagerArgs = {
      dataLayer: {
        event: 'button_click',
        checkout_name: 'Single Payment - Logged Out',
        error_message: 'Details not correct',
        button_name: 'Try Again',
        failure_number: ShowSecondAttempt ? '2' : '1'
      }
    }
    TagManager.dataLayer(tagManagerArgs);

  };

  const handleLiveChatButtonClick = () => {
    var tagManagerArgs = {
      dataLayer: {
        event: 'button_click',
        checkout_name: 'Single Payment - Logged Out',
        error_message: 'Details not correct',
        button_name: 'Live Chat',
        failure_number: '2'
      }
    }
    TagManager.dataLayer(tagManagerArgs);
    
    let anyQuestionsText = PageData?.AnyQuestionsButtonText;
    OpenChatBot(Model?.WebchatPageUrl, anyQuestionsText);
  };

  const liveBtn = () => {
    let anyQuestionsText = PageData?.AnyQuestionsButtonText;
    OpenChatBot(Model?.WebchatPageUrl, anyQuestionsText);
};

  return (
    <div className="modal-dialog">
      <div className="modal-content">
        <button
          type="button"
          className="modal-close"
          onClick={() => { handleClick(); setCallusText(PageData?.CallUsNowButtonText); }}
        ></button>
        <div className="modal-header">
          {PageData?.IncorrectDetailsHeading}
        </div>
        <div className="modal-body u-center">
          <p className="modal-para">
            {disableWebDeflect ? PageData.IncorrectDetailsContent : ShowSecondAttempt ? PageData.IncorrectDetailsSecondAttemptContent : PageData.IncorrectDetailsContent}
          </p>
        </div>
        <div className="Grid">
          <div className="Grid-cell">

            {disableWebDeflect ? (
              <>
                <button
                  type="button"
                  className="Button u-block u-marginBxxsm w-100"
                  onClick={() => handleClick(false)}
                >
                  {PageData?.TryAgainButtonText}
                </button>

                {Model?.IsGoLiveChatEnabled &&
                  <button
                    type="button"
                    className="Button Button--ghost black-border u-block u-marginBxxsm w-100"
                    onClick={() => {
                      liveBtn();
                  }}
                  >
                    {PageData?.LiveChatButtonText}
                  </button>}
              </>
            ) :

              ShowSecondAttempt ?
                (
                  <>
                    {(LayoutModel?.EnableCallBackForm && showCallUsNowButton == false) ? (
                      <>
                        <CallBackButton
                          buttonUrl={Model?.RequestCallBackPageUrl}
                          buttonText={PageData?.RequestCallBackButtonText}
                          classNames={'Button u-block u-marginBxxsm w-100'}
                        />
                        <PageLink
                          className="Button u-block u-marginBxxsm Button--ghost black-border w-100"
                          url={Model?.ContactFormUrl}
                          text={PageData?.SendMessageButtonText}
                        />
                      </>
                    )
                      :
                      (
                        <>
                          {showCallUsNowButton ? (
                            <>

                              <CallUsNowButton
                                callusNumber={callusNumber}
                                callusText={callusText}
                                isMobileSize={isMobileSize}
                                onCallUsNowClick={handleCallUsNowClick}
                                classNames={"Button u-block u-marginBxxsm w-100 "}
                              />
                              {Model?.IsGoLiveChatEnabled &&
                                (
                                  <button
                                    type="button"
                                    className="Button Button--ghost black-border u-block u-marginBxxsm w-100"
                                    onClick={handleLiveChatButtonClick}
                                  >
                                    {PageData?.LiveChatButtonText}
                                  </button>
                                )}
                            </>
                          )
                            :
                            (
                              <PageLink
                                className="Button u-block u-marginBxxsm w-100"
                                url={Model?.ContactFormUrl}
                                text={PageData?.SendMessageButtonText}
                              />
                            )}
                        </>
                      )}
                    <button
                      type="button"
                      className="Button u-block u-marginBxxsm w-100 Button--ghost black-border"
                      onClick={() => { handleTryAgainButtonClick(); handleClick(); setCallusText(PageData?.CallUsNowButtonText); }}
                    >
                      {PageData?.TryAgainButtonText}
                    </button>
                  </>
                )
                :
                (
                  <>
                    {(LayoutModel?.EnableCallBackForm && showCallUsNowButton == false) ? (
                      <>
                        <CallBackButton
                          buttonUrl={Model?.RequestCallBackPageUrl}
                          buttonText={PageData?.RequestCallBackButtonText}
                          classNames={'Button u-block u-marginBxxsm w-100'}
                        />
                        <button
                          type="button"
                          className="Button u-block u-marginBxxsm Button--ghost black-border w-100"
                          onClick={() => { handleTryAgainButtonClick(); handleClick(); setCallusText(PageData?.CallUsNowButtonText); }}
                        >
                          {PageData?.TryAgainButtonText}
                        </button>
                        <PageLink
                          className="Button u-block u-marginBxxsm Button--ghost black-border w-100"
                          url={Model?.ContactFormUrl}
                          text={PageData?.SendMessageButtonText}
                        />
                      </>
                    ) :
                      (
                        <>
                          <button
                            type="button"
                            className="Button u-block u-marginBxxsm w-100"
                            onClick={() => { handleTryAgainButtonClick(); handleClick(); setCallusText(PageData?.CallUsNowButtonText); }}
                          >
                            {PageData?.TryAgainButtonText}
                          </button>

                          {showCallUsNowButton ? (
                            <>

                              <CallUsNowButton
                                callusNumber={callusNumber}
                                callusText={callusText}
                                isMobileSize={isMobileSize}
                                onCallUsNowClick={handleCallUsNowClick}
                                classNames={"Button u-block u-marginBxxsm w-100 Button--ghost black-border"}
                              />
                            </>
                          )
                            :
                            (
                              <PageLink
                                className="Button u-block u-marginBxxsm Button--ghost black-border w-100"
                                url={Model?.ContactFormUrl}
                                text={PageData?.SendMessageButtonText}
                              />
                            )}
                        </>
                      )}
                  </>
                )}
          </div>
        </div>
      </div >
    </div >
  );
};

export default ValidationMessage;
